/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_CustomReport_CustomReportListDto_Wealthlane_ReportService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_CustomReport_CustomReportListDto_Wealthlane_ReportService_Application_Contracts';
import type { Wealthlane_ReportService_Dtos_CustomReport_CurrentPricePerShareDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CurrentPricePerShareDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportExportDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportExportDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportFileResultDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportFileResultDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportRenameDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportRenameDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportUpdateDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportUpdateDto';
import type { Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto } from '../models/Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto';
import type { Wealthlane_ReportService_Dtos_DynamicReporting_StepFrequencyDropDownDto } from '../models/Wealthlane_ReportService_Dtos_DynamicReporting_StepFrequencyDropDownDto';
import type { Wealthlane_ReportService_Dtos_ReportConfiguration_ReportSpecification } from '../models/Wealthlane_ReportService_Dtos_ReportConfiguration_ReportSpecification';
import type { Wealthlane_Shared_Hosting_Dtos_ReportDto_CustomReport_CustomReportPostDto } from '../models/Wealthlane_Shared_Hosting_Dtos_ReportDto_CustomReport_CustomReportPostDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomReportsService {

    /**
     * @param requestBody
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsValidateCustomReports(
        requestBody?: Wealthlane_Shared_Hosting_Dtos_ReportDto_CustomReport_CustomReportPostDto,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/validate-custom-reports',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsCustomReports(
        requestBody?: Wealthlane_Shared_Hosting_Dtos_ReportDto_CustomReport_CustomReportPostDto,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/custom-reports',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Updates existing custom report configuration
     * @param requestBody
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static putApiReportApiAppCustomReportsCustomReports(
        requestBody?: Wealthlane_ReportService_Dtos_CustomReport_CustomReportUpdateDto,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/report/api/app/custom-reports/custom-reports',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Remanes existing custom report to new non existing name
     * @param requestBody
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsRenameReport(
        requestBody?: Wealthlane_ReportService_Dtos_CustomReport_CustomReportRenameDto,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/rename-report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Check if report new report name is duplicate or not
     * @param reportName
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsCheckDuplicateReportName(
        reportName?: string,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/check-duplicate-report-name',
            query: {
                'reportName': reportName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get list of all custom reports
     * @param fromCreatedDate
     * @param toCreatedDate
     * @param categoryIds
     * @param areaIds
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_CustomReport_CustomReportListDto_Wealthlane_ReportService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsCustomReportList(
        fromCreatedDate?: string,
        toCreatedDate?: string,
        categoryIds?: Array<string>,
        areaIds?: Array<string>,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_CustomReport_CustomReportListDto_Wealthlane_ReportService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/custom-report-list',
            query: {
                'FromCreatedDate': fromCreatedDate,
                'ToCreatedDate': toCreatedDate,
                'CategoryIds': categoryIds,
                'AreaIds': areaIds,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get custom report by id
     * @param id
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsCustomReportById(
        id: string,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/{id}/custom-report-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Delete custom report by id
     * @param id
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static deleteApiReportApiAppCustomReportsCustomReportById(
        id: string,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/report/api/app/custom-reports/{id}/custom-report-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsSubmitAndRunReport(
        requestBody?: Wealthlane_Shared_Hosting_Dtos_ReportDto_CustomReport_CustomReportPostDto,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/submit-and-run-report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Gives custom report output file by report name
     * @param fileName
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportFileResultDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsCustumReportFileByName(
        fileName?: string,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportFileResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/custum-report-file-by-name',
            query: {
                'fileName': fileName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsReportQueryGenerationTest(
        requestBody?: Wealthlane_ReportService_Dtos_ReportConfiguration_ReportSpecification,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/report-query-generation-test',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsAmortizeToList(): CancelablePromise<Array<Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/amortize-to-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customReportId
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportExportDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsExportCustomReportJson(
        customReportId: string,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/export-custom-report-json/{customReportId}',
            path: {
                'customReportId': customReportId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppCustomReportsImportCustomReportJson(
        formData?: {
            CustomReport?: Blob;
        },
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/custom-reports/import-custom-report-json',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsAwardTypeList(): CancelablePromise<Array<Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/award-type-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_ReportService_Dtos_DynamicReporting_StepFrequencyDropDownDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsStepFrequencyList(): CancelablePromise<Array<Wealthlane_ReportService_Dtos_DynamicReporting_StepFrequencyDropDownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/step-frequency-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param date
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CurrentPricePerShareDto OK
     * @throws ApiError
     */
    public static getApiReportFMVOfCompanyByDate(
        date: string,
    ): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CurrentPricePerShareDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/f-mVOf-company-by-date/{date}',
            path: {
                'date': date,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppCustomReportsReleaseStatuses(): CancelablePromise<Array<Wealthlane_ReportService_Dtos_DynamicReporting_AmortizeToDropDownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/custom-reports/release-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
